import React, { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import SolicitorLayoutHeader from "../../components/solicitorLayoutHeader";
import { getImageFile, incrementImageCounter } from "../../actions/solicitorImages";
import { logout } from "../../actions/user";
import { push } from "connected-react-router";

const SolicitorHeaderHOC = () => {
    const dispatch = useDispatch();

    // Select all state values using useSelector
    const userRoles = useSelector(state => state.user.loggedInUser.roles);
    const locationPathName = useSelector(state => state.router.location.pathname);
    const loggedInUserToba = useSelector(state => state.user.loggedInUser.toba);
    const notificationsIconCount = useSelector(state => state.notifications.notificationsIconCount);
    const solicitorImages = useSelector(state => state.solicitorImages.images);
    const fetchingImages = useSelector(state => state.solicitorImages.fetching);
    const solicitorFileImages = useSelector(state => state.solicitorImages.fileImages);
    const imageCounter = useSelector(state => state.solicitorImages.imageCounter);
    const fetchedImageIndexes = useSelector(state => state.solicitorImages.fetchedImageIndexes);
    const solicitorHomePageInfo = useSelector(state => state.solicitorHomePageInfo.information);
    const isUserAllowedToCreateApp = useSelector(state => state.user.loggedInUser.allowedToCreateApplications);
    const solicitorGroupAllowedToApplyForDisbursements = useSelector(state => state.user.loggedInUser.solicitorGroupAllowedToApplyForDisbursements);
    const userData = useSelector(state => state.user.loggedInUser);
	const [isNavbarOpen, setIsNavbarOpen] = useState(false);

    // Action handlers using useDispatch
    const handleGetImageFile = (url) => {
        dispatch(getImageFile(url));
    };

    const handleIncrementImageCounter = (imageIndex) => {
        dispatch(incrementImageCounter(imageIndex));
    };

    const handleLogout = () => {
        dispatch(logout());
    };

    const handlePush = (url) => {
        dispatch(push(url));
    };

    return (
        <SolicitorLayoutHeader
            userRoles={userRoles}
            locationPathName={locationPathName}
            loggedInUserToba={loggedInUserToba}
            notificationsIconCount={notificationsIconCount}
            images={solicitorImages}
            incrementImageCounter={handleIncrementImageCounter}
            imageCounter={imageCounter}
            fetchedImageIndexes={fetchedImageIndexes}
            fetchingImages={fetchingImages}
            logout={handleLogout}
            push={handlePush}
            solicitorHomePageInfo={solicitorHomePageInfo}
            isUserAllowedToCreateApp={isUserAllowedToCreateApp}
            solicitorGroupAllowedToApplyForDisbursements={solicitorGroupAllowedToApplyForDisbursements}
            getImageFile={handleGetImageFile}
            solicitorFileImages={solicitorFileImages}
            isNavbarOpen={isNavbarOpen}
            setIsNavbarOpen={setIsNavbarOpen}
            userData={userData}
        />
    );
};

export default SolicitorHeaderHOC;